module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', [_vm._v("Basic")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    model: {
      value: (_vm.checkbox),
      callback: function($$v) {
        _vm.checkbox = $$v
      },
      expression: "checkbox"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.checkbox) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "true-value": "Yes",
      "false-value": "No"
    },
    model: {
      value: (_vm.checkboxCustom),
      callback: function($$v) {
        _vm.checkboxCustom = $$v
      },
      expression: "checkboxCustom"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.checkboxCustom) + "\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "indeterminate": true
    }
  }, [_vm._v("\n                Indeterminate\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('b-checkbox', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-608cf271"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/checkbox/examples/ExSimple.vue
// module id = 1003
// module chunks = 20 157